import { render, staticRenderFns } from "./CashboxUpdateComponent.vue?vue&type=template&id=aa97488e&scoped=true"
import script from "./CashboxUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./CashboxUpdateComponent.vue?vue&type=script&lang=ts"
import style0 from "./CashboxUpdateComponent.vue?vue&type=style&index=0&id=aa97488e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa97488e",
  null
  
)

export default component.exports